import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/report/commission'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  commission: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  commission: state => state.commission
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_COMMISSION = 'REQUEST_GET_COMMISSION'
const RECEIVE_GET_COMMISSION = 'RECEIVE_GET_COMMISSION'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getCommission ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting commission', { root: true })
    commit(REQUEST_GET_COMMISSION)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveCommission', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting commission', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting commission', { root: true })
        return Promise.reject(error)
      })
  },
  receiveCommission ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_COMMISSION`, extract(json))
    return json.data
  },
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_COMMISSION](state, id) {
  },
  [RECEIVE_GET_COMMISSION](state, json) {
    state.commission = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
